// WikidataDialogs.jsx
// Container for all Wikidata-related dialogs

import React from 'react';
import WikidataEntityDialog from './WikidataEntityDialog';
import WikidataEntitySearchDialog from './WikidataEntitySearchDialog';

/**
 * Container component for Wikidata entity dialogs
 * Manages both entity detail view and search dialog
 *
 * @param {Object} props
 * @param {Object} props.entityDialog - Entity detail dialog state
 * @param {Object} props.searchDialog - Entity search dialog state
 * @param {Function} props.onEntityDialogClose - Handler for closing entity detail
 * @param {Function} props.onEntitySelect - Handler for selecting entity from search
 * @param {Function} props.onSearchClose - Handler for closing search dialog
 */
export default function WikidataDialogs({
                                            entityDialog = {open: false},
                                            searchDialog,
                                            onEntityDialogClose,
                                            onEntitySelect,
                                            onSearchClose
                                        }) {
    return (
        <>
            <WikidataEntityDialog
                open={entityDialog.open}
                anchorEl={entityDialog.anchorEl}
                anchorPosition={entityDialog.anchorPosition}
                id={entityDialog.id}
                uid={entityDialog.uid}
                label={entityDialog.label}
                url={entityDialog.url}
                description={entityDialog.description}
                imageUrl={entityDialog.imageUrl}
                view={entityDialog.view}
                position={entityDialog.position}
                onClose={onEntityDialogClose}
            />

            <WikidataEntitySearchDialog
                open={searchDialog.open}
                initialQuery={searchDialog.initialQuery}
                onSelect={onEntitySelect}
                onClose={onSearchClose}
            />
        </>
    );
}
